import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_package_create_details",
  "aria-expanded": "true",
  "aria-controls": "kt_package_create_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  id: "kt_package_create_details",
  class: "collapse show"
}
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_34 = { class: "col-lg-8 fv-row" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "row mb-6" }
const _hoisted_38 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "row mb-6" }
const _hoisted_43 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_44 = { class: "col-lg-8 fv-row" }
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "row mb-6" }
const _hoisted_48 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_49 = { class: "col-lg-8 fv-row" }
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "row mb-6" }
const _hoisted_53 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_54 = { class: "col-lg-8 fv-row" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "row mb-6" }
const _hoisted_58 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_59 = { class: "col-lg-8 fv-row" }
const _hoisted_60 = { class: "fv-plugins-message-container" }
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = { class: "row mb-6" }
const _hoisted_63 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_64 = { class: "col-lg-8 fv-row" }
const _hoisted_65 = { class: "fv-plugins-message-container" }
const _hoisted_66 = { class: "fv-help-block" }
const _hoisted_67 = { class: "row mb-6" }
const _hoisted_68 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_69 = { class: "col-lg-8 fv-row" }
const _hoisted_70 = { class: "fv-plugins-message-container" }
const _hoisted_71 = { class: "fv-help-block" }
const _hoisted_72 = { class: "row mb-6" }
const _hoisted_73 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_74 = { class: "col-lg-8 fv-row" }
const _hoisted_75 = {
  disabled: "",
  value: "",
  selected: ""
}
const _hoisted_76 = ["value"]
const _hoisted_77 = { class: "row mb-6" }
const _hoisted_78 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_79 = { class: "col-lg-8 fv-row" }
const _hoisted_80 = { class: "fv-plugins-message-container" }
const _hoisted_81 = { class: "fv-help-block" }
const _hoisted_82 = { class: "row mb-6" }
const _hoisted_83 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_84 = { class: "col-lg-8 fv-row" }
const _hoisted_85 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_86 = {
  key: 0,
  type: "submit",
  id: "kt_package_create_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_87 = { class: "indicator-label" }
const _hoisted_88 = { class: "indicator-progress" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_90 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_91 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_package_create_services",
  "aria-expanded": "true",
  "aria-controls": "kt_package_create_services"
}
const _hoisted_92 = { class: "card-title m-0" }
const _hoisted_93 = { class: "fw-bolder m-0" }
const _hoisted_94 = {
  id: "kt_package_create_services",
  class: "collapse show"
}
const _hoisted_95 = { class: "card-body border-top p-9" }
const _hoisted_96 = { class: "row mb-6" }
const _hoisted_97 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_98 = { class: "col-lg-8 fv-row" }
const _hoisted_99 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_100 = { class: "indicator-label" }
const _hoisted_101 = { class: "indicator-progress" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('read', 'ads'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('adsPackagesUpdating')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitUpdate,
              "validation-schema": _ctx.packageSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('arabicTitle')) + ": ", 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "titleAr",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('adPackageTitleArlang'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.titleAr,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.packages.titleAr) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ErrorMessage, { name: "titleAr" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('englishTitle')) + ": ", 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "titleEn",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('adPackageTitleEnlang'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.titleEn,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.packages.titleEn) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ErrorMessage, { name: "titleEn" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('descriptionAr')) + ": ", 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "descriptionAr",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('descriptionAr'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.descriptionAr,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.packages.descriptionAr) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_ErrorMessage, { name: "descriptionAr" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('descriptionEn')) + ": ", 1),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "descriptionEn",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('descriptionEn'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.descriptionEn,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.packages.descriptionEn) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_ErrorMessage, { name: "descriptionEn" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('price')) + ": ", 1),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "price",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('price'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.price,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.packages.price) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_ErrorMessage, { name: "price" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate('finalPrice')) + ": ", 1),
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "finalPrice",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('finalPrice'),
                        modelValue: _ctx.packages.finalPrice,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.packages.finalPrice) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_ErrorMessage, { name: "finalPrice" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.translate('packDurationDay')) + ": ", 1),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "duration",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('PackDuration'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.duration,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.packages.duration) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_ErrorMessage, { name: "duration" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.translate('adsDurationDay')) + ": ", 1),
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "adsDuration",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('adsDuration'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.adsDuration,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.packages.adsDuration) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_ErrorMessage, { name: "adsDuration" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.translate('specialAdDurationDay')) + ": ", 1),
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "specialAdDuration",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('specialAdDuration'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.specialAdDuration,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.packages.specialAdDuration) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_ErrorMessage, { name: "specialAdDuration" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.translate('homeAdDurationDay')) + ": ", 1),
                    _createElementVNode("div", _hoisted_54, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "homeAdsDuration",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('homeAdsDuration'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.homeAdsDuration,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.packages.homeAdsDuration) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createVNode(_component_ErrorMessage, { name: "homeAdsDuration" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.translate('numberOfAds')) + ": ", 1),
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "numberOfAds",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('numberOfAds'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.numberOfAds,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.packages.numberOfAds) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createVNode(_component_ErrorMessage, { name: "numberOfAds" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.translate('specialAds')) + ": ", 1),
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "specialAds",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('specialAds'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.specialAds,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.packages.specialAds) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createVNode(_component_ErrorMessage, { name: "specialAds" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.translate('homeAds')) + ": ", 1),
                    _createElementVNode("div", _hoisted_69, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "homeAds",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('homeAds'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.homeAds,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.packages.homeAds) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"]),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _createVNode(_component_ErrorMessage, { name: "homeAds" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("label", _hoisted_73, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('type')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "type",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.packages.type,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.packages.type) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_75, _toDisplayString(_ctx.translate('type')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (type) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: type.id,
                              value: type.id
                            }, _toDisplayString(type.title), 9, _hoisted_76))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.translate('sort')) + ": ", 1),
                    _createElementVNode("div", _hoisted_79, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "sort",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('sort'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.sort,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.packages.sort) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"]),
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, [
                          _createVNode(_component_ErrorMessage, { name: "sort" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.translate('color')) + ": ", 1),
                    _createElementVNode("div", _hoisted_84, [
                      _createVNode(_component_Field, {
                        type: "color",
                        name: "color",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('color'),
                        disabled: _ctx.createdPackage,
                        modelValue: _ctx.packages.color,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.packages.color) = $event))
                      }, null, 8, ["placeholder", "disabled", "modelValue"])
                    ])
                  ])
                ]),
                (!_ctx.createdPackage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                      _createElementVNode("button", {
                        type: "reset",
                        class: "btn btn-white btn-active-light-primary me-2",
                        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                      }, _toDisplayString(_ctx.translate('discard')), 1),
                      (_ctx.can('update', 'ads'))
                        ? (_openBlock(), _createElementBlock("button", _hoisted_86, [
                            _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.translate('saveChanges')), 1),
                            _createElementVNode("span", _hoisted_88, [
                              _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                              _hoisted_89
                            ])
                          ], 512))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('update', 'ads'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("h3", _hoisted_93, _toDisplayString(_ctx.translate('packageServices')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("label", _hoisted_97, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.translate('Services')), 1)
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createVNode(_component_Multiselect, {
                    ref: "multiselect",
                    modelValue: _ctx.selectedServices,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedServices) = $event)),
                    mode: "tags",
                    "close-on-select": false,
                    loading: _ctx.loading,
                    searchable: true,
                    "create-option": true,
                    options: _ctx.services,
                    placeholder: _ctx.translate('selectServices'),
                    valueProp: "id",
                    label: _ctx.multiSelectLabel,
                    noResultsText: _ctx.translate('noResultsFound')
                  }, null, 8, ["modelValue", "loading", "options", "placeholder", "label", "noResultsText"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_package_create_services_submit",
                ref: "submitServicesButton",
                class: "btn btn-primary",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onSubmitServices && _ctx.onSubmitServices(...args)))
              }, [
                _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_101, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_102
                ])
              ], 512)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}